import { Dispatch, FunctionComponent, SetStateAction, useContext } from 'react'
import { ThemeContext } from 'styled-components'

import StandardButton from 'design-system/Buttons/StandardButton'
import Dropdown from 'design-system/Popovers/Dropdown'

import Spacer from 'components/Spacer'

import BathRangeInput from '../SelectionInputs/BathRangeInput'
import { IBathProps } from '../types'
import { ApplyButtonContainer, DropdownCard, RightAlignedFlexRow } from './Shared'

interface IProps {
  buttonElement: HTMLDivElement | null
  visible: boolean
  error: string
  setError: Dispatch<SetStateAction<string>>
  setVisible: Dispatch<SetStateAction<boolean>>
  onApply: () => void
}

const PriceRangeDropdown: FunctionComponent<IProps & IBathProps> = ({
  buttonElement,
  visible,
  setVisible,
  error,
  setError,
  onApply,
  resetBathSelections,
  selectedBathRange,
  setSelectedBathRange,
}) => {
  const theme = useContext(ThemeContext)

  return (
    <Dropdown
      referenceElement={buttonElement}
      visible={visible}
      setVisible={setVisible}
      yOffset={theme.spacings[8]}
      placement="bottom-start"
    >
      <DropdownCard width={430}>
        <BathRangeInput
          selectedBathRange={selectedBathRange}
          setSelectedBathRange={setSelectedBathRange}
          onError={setError}
        />
        <Spacer size={theme.spacings[16]} />
        <RightAlignedFlexRow>
          <ApplyButtonContainer>
            <StandardButton
              type="tertiary"
              size="small"
              label="Reset"
              onClick={resetBathSelections}
              disabled={!selectedBathRange.min && !selectedBathRange.max}
              fullWidth
            />
          </ApplyButtonContainer>
          <ApplyButtonContainer>
            <StandardButton
              type="primary"
              size="small"
              label="Apply"
              onClick={onApply}
              disabled={!!error}
              fullWidth
            />
          </ApplyButtonContainer>
        </RightAlignedFlexRow>
      </DropdownCard>
    </Dropdown>
  )
}

export default PriceRangeDropdown
